import { startBarcodeScanner, stopBarcodeScanner } from './barcodeScanner';

const THIRTY_SECONDS = 30 * 1000;
const DEFOCUS_POLL_MS = 500;

const checkIfInputShouldBeDefocused = () => {
  const now = new Date();
  if (!window.lastEntry) {
    return;
  }
  if (now - THIRTY_SECONDS > window.lastEntry) {
    if (window.eanRef) {
      if (window.barcodeOpen === false) {
        console.log('have ref but barcodeOpen is false, ignoring');
        return;
      }
      window.eanRef.blur();
      console.log('blur');
    }
  }
};

export const startHiddenScan = (onScan, onStatus) => {
  startBarcodeScanner(onScan, onStatus);
  window.barcodeOpen = true;
  window.barCodeIntervalId = setInterval(
    checkIfInputShouldBeDefocused,
    DEFOCUS_POLL_MS,
  );
};

export const stopHiddenScan = () => {
  stopBarcodeScanner();
  window.barcodeOpen = false;
  clearInterval(window.barCodeIntervalId);
};
